var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';
import * as React from 'react';
export const TextField = styled((_a) => {
    var { label, name, id, sx, required, error, helperText } = _a, props = __rest(_a, ["label", "name", "id", "sx", "required", "error", "helperText"]);
    // Generate a unique ID if one isn't provided
    const inputId = id || name || `input-${Math.random().toString(36).substring(2, 9)}`;
    // Generate an ID for the helper text for proper association
    const helperTextId = `${inputId}-helper-text`;
    return (_jsxs(Stack, Object.assign({ spacing: '5px' }, { children: [_jsxs(InputLabel, Object.assign({ htmlFor: inputId, required: required, error: error, sx: {
                    fontWeight: 600,
                    color: error ? 'error.main' : '#000',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    '& .required-star': {
                        marginLeft: '4px',
                        color: 'error.main',
                    },
                } }, { children: [label, required && !props['aria-required'] && (_jsx("span", Object.assign({ className: 'required-star', "aria-hidden": 'true' }, { children: "*" })))] })), _jsx(OutlinedInput, Object.assign({ id: inputId, name: name, size: 'small', error: error }, props, { "aria-required": required ? 'true' : undefined, "aria-invalid": error ? 'true' : 'false', "aria-describedby": helperText ? helperTextId : undefined, sx: Object.assign({ borderRadius: 0 }, sx) })), helperText && (_jsx(FormHelperText, Object.assign({ id: helperTextId, error: error, sx: {
                    margin: '4px 0 0 0',
                    lineHeight: 1.2,
                } }, { children: helperText })))] })));
})(({ theme, error }) => {
    var _a, _b, _c, _d, _e;
    return ({
        marginTop: theme.spacing(2),
        borderColor: error ? theme.palette.error.main : (_a = theme.account) === null || _a === void 0 ? void 0 : _a.page.heading,
        '& fieldset': {
            borderColor: error ? theme.palette.error.main : (_b = theme.account) === null || _b === void 0 ? void 0 : _b.page.heading,
        },
        '&:hover fieldset': {
            borderColor: error ? theme.palette.error.main : (_c = theme.account) === null || _c === void 0 ? void 0 : _c.page.heading,
        },
        '& .Mui-focused fieldset': {
            borderColor: error ? theme.palette.error.main : (_d = theme.account) === null || _d === void 0 ? void 0 : _d.page.heading,
        },
        // input focused
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: error ? theme.palette.error.main : (_e = theme.account) === null || _e === void 0 ? void 0 : _e.page.heading,
            borderWidth: '2px', // Increase border width for better focus visibility
        },
        // Improve focus visibility for keyboard navigation
        '& .MuiOutlinedInput-root:focus-visible': {
            outline: `3px solid ${theme.palette.primary.main}`,
            outlineOffset: '2px',
        },
    });
});
